module.exports = "/_next/static/images/headphones-line-1a93d2e17ee9e8cb5d91b9fe1023d3fa.svg";